export default __webpack_public_path__ + "static/media/AnthonyUgwuanyi.16cc29d4.svg";